// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwNotification-wrap","content":"CwNotification-content","error":"CwNotification-error","informational":"CwNotification-informational","warning":"CwNotification-warning","successful":"CwNotification-successful","text":"CwNotification-text","icon":"CwNotification-icon","closeIcon":"CwNotification-closeIcon","children":"CwNotification-children"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwnotification/CwNotification.scss
// module id = 1019
// module chunks = 10